export default __webpack_public_path__ + "static/media/ProfilSoftware_logo_nopadding.8b4cc2c4.svg";